/**
 * API 相关常量
 */
export const ApiConstants = {
  // 基础 URL
  BASE_URL: '/api',
  // 超时时间(ms)
  TIMEOUT: 10000,
  // 成功状态码
  SUCCESS_CODE: 200,
  // 未授权状态码
  UNAUTHORIZED_CODE: 401,
}

/**
 * 路由相关
 */
export const RouteConstants = {
  // 工作台
  ADMIN_ROOT_DIRECTORY: 'admin',
  // 授课端
  TEACH_COURSE_ROOT_DIRECTORY: 'teach-course',
}

/**
 * 富文本编辑器
 */
export const EditorConstants = {
  // API_KEY: 'ota05lzddq7efz27cmnjna0xeqwi3m2ggitqgvgvnczpwl7w',
  API_KEY: 'biik4nzvnlzlo746nhzyuna9hv4s54xwueptsy8urkj6isgb',
}

/**
 * 用户相关
 */
export const UserConstants = {
  // TOKEN
  TOKEN: 'token',
}

export const TableOptions = {
  WIDTH_SMALL_1: '90px',
  WIDTH_SMALL_2: '120px',
}
